export enum ChartModeStyle {
    Normal = 0,
    LeftAndRightLabels = 1
}